
import {createRouter, createWebHashHistory} from 'vue-router'
import authService from '@/services/authService';
import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login'),
  },
  {

    path: '/dashboard',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/dashboard/Dashboard.vue'
            ),
      },

      {
        path: '/concept',
        name: 'Concept',
        component: () => import('@/views/concept/table.vue'),
      },
      {
        path: '/concept-networks',
        name: 'Networks Log',
        component: () => import('@/views/concept-networks/index.vue'),
      },
      {
        path: '/apps',
        name: 'Apps',
        component: () => import('@/views/apps/table.vue'),
      },
      {
        path: '/apps/create',
        name: 'App Create',
        component: () => import('@/views/apps/create.vue'),
      },
      {
        path: '/apps/edit/:id',
        name: 'Edit App',
        component: () => import('@/views/apps/edit.vue'),
        props: true,
      },
      {
        path: '/concept/upload',
        name: 'Concept Upload',
        component: () => import('@/views/concept/upload.vue'),
      },
      {
        path: '/creative-log',
        name: 'Creative Log',
        component: () => import('@/views/creative-log/table.vue'),
      },
      {
        path: '/creative-dashboard',
        redirect: '/creative-charts',
      },
      {
        path: '/creative-charts',
        name: 'Charts & Diagrams',
        component: () => import('@/views/creative-dashboard/index.vue'),
      },
      {
        // Compare periods is a tab of Charts & Diagrams now.
        path: '/creative-charts/compare',
        redirect: { path: '/creative-charts', query: { tab: 'compare' } },
      },
      {
        path: '/concept/creatives/:id',
        name: 'Creative List',
        component: () => import('@/views/concept/creatives.vue'),
        props: true,
      },
      {
        path: '/network/applovin',
        name: 'Applovin',
        component: () => import('@/views/network/applovin/table.vue'),
      },
      {
        path: '/network/applovin/create',
        name: 'Applovin Create',
        component: () => import('@/views/network/applovin/create.vue'),
      },
      {
        path: '/network/applovin/create-combination',
        name: 'Applovin Create Combination',
        component: () => import('@/views/network/applovin/create-combination.vue'),
      },
      {
        path: '/network/google-ads',
        name: 'Google Ads',
        component: () => import('@/views/network/google-ads/table.vue'),
      },
      {
        path: '/network/google-ads/create',
        name: 'Google Ads Create',
        component: () => import('@/views/network/google-ads/create.vue'),
      },
      {
        path: '/network/facebook-ads',
        name: 'Facebook Ads',
        component: () => import('@/views/network/facebook-ads/table.vue'),
        },
        {
          path: '/network/facebook-ads/create',
          name: 'Facebook Ads Create',
          component: () => import('@/views/network/facebook-ads/create.vue'),
        },
        {
          path: '/network/mintegral',
          name: 'Mintegral',
          component: () => import('@/views/network/mintegral/table.vue'),
        },
        {
          path: '/network/mintegral/create',
          name: 'Mintegral Create',
          component: () => import('@/views/network/mintegral/create.vue'),
        },
        {
          path: '/network/unity-ads',
          name: 'Unity Ads',
          component: () => import('@/views/network/unity-ads/table.vue'),
        },
        {
          path: '/network/unity-ads/create',
          name: 'Unity Ads Create',
          component: () => import('@/views/network/unity-ads/create.vue'),
        },

      {
        path: '/adjust/raw-report',
        name: 'Raw Report',
        component: () => import('@/views/reports/raw/table.vue'),
      },
      {
        path: '/adjust/raw-report/:id',
        name: 'Raw Report More',
        component: () => import('@/views/reports/raw/more.vue'),
        props: true,
      },

      {
        path: '/adjust/group-ad-name-report',
        name: 'Report Week',
        component: () => import('@/views/reports/group-ad-name/table.vue'),
      },
      {
        path: '/adjust/group-ad-name-month-report',
        name: 'Report Month',
        component: () => import('@/views/reports/group-ad-name-month/table.vue'),
      },
      {
        path: '/adjust/group-code-week-report',
        name: 'Report Code Week',
        component: () => import('@/views/reports/group-code-week/table.vue'),
      },
      {
        path: '/adjust/group-code-day-report',
        name: 'Report Code Day',
        component: () => import('@/views/reports/group-code-day/table.vue'),
      },
      {
        path: '/adjust/group-code-month-report',
        name: 'Report Code Month',
        component: () => import('@/views/reports/group-code-month/table.vue'),
      },
      {
        path: '/adjust/group-code-month-vid-report',
        name: 'Report Code Month VID',
        component: () => import('@/views/reports/group-code-month-vid/table.vue'),
      },
      {
        path: '/adjust/group-code-month-pl-report',
        name: 'Report Code Month PL',
        component: () => import('@/views/reports/group-code-month-pl/table.vue'),
      },

      {
        path: '/naming/create',
        name: 'New Number',
        component: () => import('@/views/naming/create.vue'),
      },

      {
        path: '/playables/live',
        name: 'Playables Live',
        component: () => import('@/views/playables/live.vue'),
      },

    ],
  },

]

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return {top: 0}
  },
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = authService.isAuthenticated();
  if (to.meta.requiresAuth) {
    if (isAuthenticated) {
      next();
    } else {
      try {
        const user = await authService.getUser();
        if (Object.keys(user).length != 0 ) {
          next();
        } else {

          next('/');
        }
      } catch (error) {
        next('/');
      }
    }
  } else if (to.path === '/login' && isAuthenticated) {
    next('/dashboard');
  } else {
    next();
  }
});
export default router
